import React, { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ShopsListResponse, ShopsQuery, fetchShopsList } from "../shopsApi"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"

const useStyles = makeStyles()((_theme) => ({
    wrap: {
        width: "16rem",
        backgroundColor: "white",
    },
}))

type SelectShopProps = Readonly<{
    shopId?: string
    setShopId: React.Dispatch<React.SetStateAction<string | undefined>>
}>
const selectShops = (data: ShopsListResponse) => data?.shops || []

const ALL_VALUE = "All"

export function SelectShop({ shopId, setShopId }: SelectShopProps) {
    const { merchantId } = useMerchant()
    const { classes } = useStyles()

    const [shop, setShop] = useState<string | undefined>(shopId || ALL_VALUE)

    const { data: allShops = [] } = useApiQuery(fetchShopsList, {
        queryName: ShopsQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: selectShops,
    })

    return (
        <FormControl className={classes.wrap}>
            <LocalizedStrict id="select-shop">
                <InputLabel id="shop-picker">Shop</InputLabel>
            </LocalizedStrict>

            <LocalizedStrict id="select-shop-label" attrs={{ label: true }}>
                <Select
                    label="Shop"
                    value={shop}
                    onChange={(e) => {
                        const value = e.target.value
                        if (value !== ALL_VALUE) {
                            setShopId(value)
                            setShop(value)
                        } else {
                            setShopId(undefined)
                            setShop(value)
                        }
                    }}
                >
                    <MenuItem key={ALL_VALUE} value={ALL_VALUE}>
                        <LocalizedStrict id="select-shop-all">
                            <>All</>
                        </LocalizedStrict>
                    </MenuItem>

                    {allShops?.map((element) => {
                        return (
                            <MenuItem key={element.id} value={element.id}>
                                {element.name}
                            </MenuItem>
                        )
                    })}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
